import { login } from '@/services/login/loginService';
import type { StoredAuthTokens } from '@/types/auth';
import type { User } from '@/types/user';
import { mapApiTokensToStored } from '@/utils/authTokens';

type FetchCurrentUserOptions = {
  rethrowOnError?: boolean;
  useGlobalErrorHandler?: boolean;
  clearOnError?: boolean;
};

type ReloginAfterPasswordUpdateParams = {
  email: string;
  password: string;
  currentUser?: User;
  setAuthTokens: (tokens?: StoredAuthTokens) => void;
  syncCurrentUser: (user?: User) => void;
  fetchCurrentUser: (
    options?: FetchCurrentUserOptions,
  ) => Promise<User | undefined>;
};

export const reloginAfterPasswordUpdate = async ({
  email,
  password,
  currentUser,
  setAuthTokens,
  syncCurrentUser,
  fetchCurrentUser,
}: ReloginAfterPasswordUpdateParams): Promise<User | undefined> => {
  const tokens = await login({ email, password });
  setAuthTokens(mapApiTokensToStored(tokens));

  const optimisticUser = currentUser
    ? {
        ...currentUser,
        update_password_required: false,
      }
    : undefined;

  if (currentUser) {
    syncCurrentUser(optimisticUser);
  }

  const freshUser = await fetchCurrentUser({
    useGlobalErrorHandler: false,
    clearOnError: false,
  });

  if (freshUser) {
    syncCurrentUser(freshUser);
    return freshUser;
  }

  return optimisticUser;
};
